import { render, staticRenderFns } from "./NivelUno.vue?vue&type=template&id=35cfef16"
import script from "./NivelUno.vue?vue&type=script&lang=js"
export * from "./NivelUno.vue?vue&type=script&lang=js"
import style0 from "../main.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports